import { spacingStyling } from 'src/constants/spacing';
import type { SxProp } from 'src/types/mui';

export const contentStyles: SxProp = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
};

export const mobileContentStyles: SxProp = {
  height: '100%',
};

export const leftMenuWrapperStyles: SxProp = theme => ({
  minWidth: '340px',
  border: theme.constantStyles?.paperBorder,
  borderRadius: theme.constantStyles?.paperBorderRadius,
  height: '100%',
  overflow: 'auto',
});

export const leftMenuTabsContainerStyles: SxProp = theme => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  gap: 2,
});

export const leftMobileMenuWrapperStyles: SxProp = theme => ({
  height: '100%',
  border: theme.constantStyles?.paperBorder,
  borderRadius: theme.constantStyles?.paperBorderRadius,
  overflow: 'auto',
});

export const contentWrapperStyles: SxProp = theme => ({
  width: '100%',
  border: theme.constantStyles?.paperBorder,
  borderRadius: theme.constantStyles?.paperBorderRadius,
  overflowX: 'hidden',
  overflowY: 'auto',
  position: 'relative',
});

export const mobileContentWrapperStyles: SxProp = {
  width: '100%',
  position: 'relative',
};

export const paperStyles: SxProp = theme => ({
  p: spacingStyling.homePageLayout,
  mt: 3,
  borderRadius: 2,
  height: '95%',

  [theme.breakpoints.down('sm')]: {
    mt: 1.5,
  },
});

export const inboxWrapperStyles: SxProp = theme => ({
  display: 'grid',
  gridTemplateColumns: '340px 1fr',
  gap: 1,
  height: '100%',
  overflow: 'hidden',

  [theme.breakpoints.down('sm')]: {
    display: 'block',
  },
});
